import { grid } from './config';

export * from './colors';

export const themeConfig = {
  grid,
};
